import { gridPopUpEditorStyle, uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

const { datePickerStyle } = ComponentSettings;
export default (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),
    ...gridPopUpEditorStyle({ palette }),
    ...datePickerStyle({ palette, iconFontFamily }),
  },
  myReportsContainer: {
    overflowY: 'auto',
    flex: 1,
    '& .tab-header': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
  },
  myReportsGrid: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '& .campaign-details-list-container': {
      padding: '0 0 0 32px', // There should be no white space at right
    },
    '& .toolbar-container': {
      background: '#fff',
      '& .container-fluid': {
        paddingLeft: 8,
      },
    },
    '& .report-name-link': {
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
    },
  },
});
